var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRlVehicleMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 17h10v-2H4v2z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10a1 1 0 001-1V1.843c0-.57-.987-.905-2.27-1.357-1.84-.648-7.62-.648-9.46 0C2.986.938 2 1.273 2 1.843V9a1 1 0 001 1h12z",
    fill: "#242222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15a1 1 0 001-1V3.843c0-.57-.987-.905-2.27-1.357-1.84-.648-9.62-.648-11.46 0C1.986 2.938 1 3.273 1 3.843V14a1 1 0 001 1h14z",
    fill: "#7AE1E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.104 8.511a13.992 13.992 0 012.871-.304v-.003L9 8.206l.026-.002v.003c.962.003 1.924.103 2.87.304.715.153 1.445.36 2.088.62.543-1.2 1.22-2.743 1.22-2.743-.76-.59-2.051-.99-3.263-1.252a13.977 13.977 0 00-2.915-.315v-.003L9 4.82l-.026-.002v.003c-.977.003-1.954.107-2.915.315-1.212.262-2.503.661-3.263 1.252 0 0 .677 1.543 1.22 2.743.643-.26 1.374-.467 2.088-.62zM15.567 6.993l-1.431 2.856v4.042h1.454l-.023-6.898zM2.433 6.993l1.43 2.856v4.042H2.41l.023-6.898z",
    fill: "#645839"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.285 3L13 4.736s1.567.82 3 1.264v-.197c0-.234-.075-.464-.16-.69-.357-.802-1.312-1.42-2.555-2.113zM4.715 3c-1.243.693-2.198 1.31-2.553 2.113-.087.226-.162.456-.162.69V6c1.433-.444 3-1.264 3-1.264L4.715 3z",
    fill: "#49515D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 46a2 2 0 002 2h12a2 2 0 002-2V19a2 2 0 00-2-2H3a2 2 0 00-2 2v27z",
    fill: "#303332"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 45h1V20H4v25zM7 45h1V20H7v25zM10 45h1V20h-1v25zM13 45h1V20h-1v25z",
    fill: "#666B68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRlVehicleMarker);
export default __webpack_public_path__ + "static/media/rl-vehicle-marker.01361554c0b917ad3b037cf790f945d3.svg";
export { ForwardRef as ReactComponent };